var _defs, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _polyline18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1e53;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "64.36 26.5 73.93 26.5 73.93 35.9 64.36 35.9 64.36 26.5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "73.93 26.5 83.5 26.5 83.5 35.9 73.93 35.9 73.93 26.5"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.5 35.9 26.07 35.9 26.07 45.3 16.5 45.3 16.5 35.9"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.07 35.9 35.64 35.9 35.64 45.3 26.07 45.3 26.07 35.9"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "45.21 35.9 54.79 35.9 54.79 45.3 45.21 45.3 45.21 35.9"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "54.79 35.9 64.36 35.9 64.36 45.3 54.79 45.3 54.79 35.9"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "64.36 35.9 73.93 35.9 73.93 45.3 64.36 45.3 64.36 35.9"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.5 45.3 26.07 45.3 26.07 54.7 16.5 54.7 16.5 45.3"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.64 45.3 45.21 45.3 45.21 54.7 35.64 54.7 35.64 45.3"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "54.79 45.3 64.36 45.3 64.36 54.7 54.79 54.7 54.79 45.3"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "73.93 45.3 83.5 45.3 83.5 54.7 73.93 54.7 73.93 45.3"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.5 54.7 26.07 54.7 26.07 64.1 16.5 64.1 16.5 54.7"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.07 54.7 35.64 54.7 35.64 64.1 26.07 64.1 26.07 54.7"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.07 64.1 35.64 64.1 35.64 73.5 26.07 73.5 26.07 64.1"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.64 64.1 45.21 64.1 45.21 73.5 35.64 73.5 35.64 64.1"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "45.21 64.1 54.79 64.1 54.79 73.5 45.21 73.5 45.21 64.1"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "54.79 64.1 64.36 64.1 64.36 73.5 54.79 73.5 54.79 64.1"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "73.93 64.1 83.5 64.1 83.5 73.5 73.93 73.5 73.93 64.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f9b6d797667720018f80f3965bb84483.svg";
export { ForwardRef as ReactComponent };